import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Pagination from '../../Pagination';
import { trackEvent } from '../../tools/eventTracking';
export default function PaginationPlugin(_ref, _ref2) {
  var change = _ref.change;
  var pagination = _ref2.pagination;

  if (!pagination) {
    return null;
  }

  return {
    bottomRight: /*#__PURE__*/React.createElement(Pagination, _objectSpread(_objectSpread({}, pagination), {}, {
      onChange: function onChange(e) {
        change('paginate', e);
        pagination.onChange && pagination.onChange(e);
        trackEvent({
          componentName: 'Table',
          eventName: 'pagination',
          eventValue: JSON.stringify(e)
        });
      }
    }))
  };
}